// ----------------------------------------------------------------------------
// Component: Narrow Campaign Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_narrow-campaign-block.scss';